import { createFileRoute, Navigate } from "@tanstack/react-router";
import { usePermissions } from "@client/hooks/use-permissions";

export const Route = createFileRoute("/_app/tenant-settings/")({
  component: TenantSettingsIndex,
});

/**
 * 落地重定向：管理员进入团队管理的成员管理 Tab；非管理员（如发布审批获批者，33 号方案）进发布审核。
 * beforeLoad 无法消费 React 权限状态，改为组件内重定向。
 */
function TenantSettingsIndex() {
  const { isTenantAdmin } = usePermissions();
  if (isTenantAdmin) {
    return <Navigate to="/tenant-settings/users" search={{ tab: "members" }} />;
  }
  return <Navigate to="/tenant-settings/publications" search={{ tab: "pending" }} />;
}
